import { useEffect, useState } from 'react'
import Logo from 'src/components/ui/Logo'
import { BagCartOutline } from 'src/components/Icons/BagCartOutline'
import { useCartToggleButton } from 'src/sdk/cart/useCartToggleButton'
import { useDebounce } from 'src/hooks/useDebounce'
import { Link } from 'gatsby'

import { SearchInput } from '../../SearchInput'
import { SidebarMenu } from '../SideBarMenu/SideBarMenu'
import { ButtonIcon } from '../ButtonIcon'
import { HeaderMobileFixed } from './HeaderMobileFixed'
import { TurboPickupButton } from '../TurboPickupInPoint'
import { PostalCodeInput } from '../PostalCode'

const SHOW_STICKY_SCROLL = 200

type Props = {
  onClickLogin: () => void
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
  handleLogoClick: () => void
}

export const MOBILE_MENU_BADGE_DIMENSIONS = {
  width: '20px',
  height: '20px',
  bottom: '16px',
  left: '22px',
}

export default function HeaderMobile({
  isOpen,
  onClickLogin,
  setIsOpen,
  handleLogoClick,
}: Props) {
  const [showFixed, setShowFixed] = useState(false)

  const cartButtonProps = useCartToggleButton()

  const debouncedScroll = useDebounce(() => {
    setShowFixed(window.scrollY > SHOW_STICKY_SCROLL)
  }, 80)

  useEffect(() => {
    window.addEventListener('scroll', debouncedScroll)

    return () => {
      window.removeEventListener('scroll', debouncedScroll)
    }
  }, [debouncedScroll])

  return (
    <>
      <header className="restructure-small-desktop:hidden">
        <div className="p-4">
          <div className="flex justify-between w-full mb-2">
            <Link
              className="flex items-center"
              to="https://www.decathlon.com.br"
              onClick={handleLogoClick}
              aria-label="Ir para a página inicial da Decathlon"
            >
              <Logo width={134} height={20} bgFill="#3643BA" />
            </Link>

            <div className="flex items-center gap-2">
              <TurboPickupButton />

              <SidebarMenu onClickLogin={onClickLogin} showTitle={false} />

              <ButtonIcon
                aria-label="Ir para o carrinho"
                badgeValue={cartButtonProps.itemsTotal}
                badgeDimensions={{ ...MOBILE_MENU_BADGE_DIMENSIONS }}
                {...cartButtonProps}
              >
                <BagCartOutline className="w-6 h-6" />
              </ButtonIcon>
            </div>
          </div>
          <SearchInput isOpen={isOpen} setIsOpen={setIsOpen} thinStyle />
        </div>
        <PostalCodeInput variant="mobile" />
      </header>

      <HeaderMobileFixed
        visible={showFixed && !isOpen}
        onClickLogin={onClickLogin}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        handleLogoClick={handleLogoClick}
      />
    </>
  )
}
